import { render } from "./MeliAccounts.vue?vue&type=template&id=3e0b9cbd"
import script from "./MeliAccounts.vue?vue&type=script&lang=js"
export * from "./MeliAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__